let wasm;

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return decodeText(ptr, len);
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = cachedTextEncoder.encodeInto(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

function takeFromExternrefTable0(idx) {
    const value = wasm.__wbindgen_externrefs.get(idx);
    wasm.__externref_table_dealloc(idx);
    return value;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

const cachedTextEncoder = new TextEncoder();

if (!('encodeInto' in cachedTextEncoder)) {
    cachedTextEncoder.encodeInto = function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length
        };
    }
}

let WASM_VECTOR_LEN = 0;

/**
 * Returns the minimum recommended plate thickness in mm.
 *
 * Given material, geometry, and force, computes the smallest thickness that
 * would satisfy all bearing and bending stress checks.
 * @param {number} bolt_spacing
 * @param {string} bolt_size
 * @param {number} bracket_width
 * @param {string} material
 * @param {number} pin_diameter
 * @param {number} pin_count
 * @param {number} expected_force_per_pin
 * @returns {number}
 */
export function wasm_minimum_thickness(bolt_spacing, bolt_size, bracket_width, material, pin_diameter, pin_count, expected_force_per_pin) {
    const ptr0 = passStringToWasm0(bolt_size, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(material, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.wasm_minimum_thickness(bolt_spacing, ptr0, len0, bracket_width, ptr1, len1, pin_diameter, pin_count, expected_force_per_pin);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return ret[0];
}

/**
 * Validate bolt size value.
 *
 * Accepts standard ISO metric bolt sizes: M3, M4, M5, M6, M8, M10, M12.
 * Returns Ok(()) if valid, or an error message if invalid.
 * @param {string} value
 */
export function wasm_validate_bolt_size(value) {
    const ptr0 = passStringToWasm0(value, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.wasm_validate_bolt_size(ptr0, len0);
    if (ret[1]) {
        throw takeFromExternrefTable0(ret[0]);
    }
}

/**
 * Validate bolt spacing value.
 *
 * Returns Ok(()) if valid, or an error message if invalid.
 * @param {number} value
 */
export function wasm_validate_bolt_spacing(value) {
    const ret = wasm.wasm_validate_bolt_spacing(value);
    if (ret[1]) {
        throw takeFromExternrefTable0(ret[0]);
    }
}

/**
 * Validate bracket height value.
 *
 * Returns Ok(()) if valid, or an error message if invalid.
 * @param {number} value
 */
export function wasm_validate_bracket_height(value) {
    const ret = wasm.wasm_validate_bracket_height(value);
    if (ret[1]) {
        throw takeFromExternrefTable0(ret[0]);
    }
}

/**
 * Validate bracket width value.
 *
 * Returns Ok(()) if valid, or an error message if invalid.
 * @param {number} value
 */
export function wasm_validate_bracket_width(value) {
    const ret = wasm.wasm_validate_bracket_width(value);
    if (ret[1]) {
        throw takeFromExternrefTable0(ret[0]);
    }
}

/**
 * Validate expected force per pin value.
 *
 * Returns Ok(()) if valid, or an error message if invalid.
 * @param {number} value
 */
export function wasm_validate_expected_force(value) {
    const ret = wasm.wasm_validate_expected_force(value);
    if (ret[1]) {
        throw takeFromExternrefTable0(ret[0]);
    }
}

/**
 * Validate material value.
 *
 * Accepts: aluminum, stainless_steel, carbon_steel, brass.
 * Returns Ok(()) if valid, or an error message if invalid.
 * @param {string} value
 */
export function wasm_validate_material(value) {
    const ptr0 = passStringToWasm0(value, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.wasm_validate_material(ptr0, len0);
    if (ret[1]) {
        throw takeFromExternrefTable0(ret[0]);
    }
}

/**
 * Validate pin count value.
 *
 * Returns Ok(()) if valid, or an error message if invalid.
 * @param {number} value
 */
export function wasm_validate_pin_count(value) {
    const ret = wasm.wasm_validate_pin_count(value);
    if (ret[1]) {
        throw takeFromExternrefTable0(ret[0]);
    }
}

/**
 * Validate pin diameter value.
 *
 * Returns Ok(()) if valid, or an error message if invalid.
 * @param {number} value
 */
export function wasm_validate_pin_diameter(value) {
    const ret = wasm.wasm_validate_pin_diameter(value);
    if (ret[1]) {
        throw takeFromExternrefTable0(ret[0]);
    }
}

/**
 * Validate plate thickness value.
 *
 * Returns Ok(()) if valid, or an error message if invalid.
 * @param {number} value
 */
export function wasm_validate_plate_thickness(value) {
    const ret = wasm.wasm_validate_plate_thickness(value);
    if (ret[1]) {
        throw takeFromExternrefTable0(ret[0]);
    }
}

/**
 * Run full stress analysis on a plate configuration.
 *
 * Takes all plate parameters as flat values (wasm-bindgen doesn't support structs).
 * Runs both basic constraint checks and engineering stress checks with 2x safety factor.
 * Returns Ok(()) if the plate passes all checks, or Err(String) with the first violation.
 * @param {number} bolt_spacing
 * @param {string} bolt_size
 * @param {number} bracket_height
 * @param {number} bracket_width
 * @param {string} material
 * @param {number} pin_diameter
 * @param {number} pin_count
 * @param {number} plate_thickness
 * @param {number} expected_force_per_pin
 */
export function wasm_validate_stress(bolt_spacing, bolt_size, bracket_height, bracket_width, material, pin_diameter, pin_count, plate_thickness, expected_force_per_pin) {
    const ptr0 = passStringToWasm0(bolt_size, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(material, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.wasm_validate_stress(bolt_spacing, ptr0, len0, bracket_height, bracket_width, ptr1, len1, pin_diameter, pin_count, plate_thickness, expected_force_per_pin);
    if (ret[1]) {
        throw takeFromExternrefTable0(ret[0]);
    }
}

const EXPECTED_RESPONSE_TYPES = new Set(['basic', 'cors', 'default']);

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);
            } catch (e) {
                const validResponse = module.ok && EXPECTED_RESPONSE_TYPES.has(module.type);

                if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else {
                    throw e;
                }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };
        } else {
            return instance;
        }
    }
}

function __wbg_get_imports() {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbindgen_cast_2241b6af4c4b2941 = function(arg0, arg1) {
        // Cast intrinsic for `Ref(String) -> Externref`.
        const ret = getStringFromWasm0(arg0, arg1);
        return ret;
    };
    imports.wbg.__wbindgen_init_externref_table = function() {
        const table = wasm.__wbindgen_externrefs;
        const offset = table.grow(4);
        table.set(0, undefined);
        table.set(offset + 0, undefined);
        table.set(offset + 1, null);
        table.set(offset + 2, true);
        table.set(offset + 3, false);
    };

    return imports;
}

function __wbg_finalize_init(instance, module) {
    wasm = instance.exports;
    __wbg_init.__wbindgen_wasm_module = module;
    cachedUint8ArrayMemory0 = null;


    wasm.__wbindgen_start();
    return wasm;
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (typeof module !== 'undefined') {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();
    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }
    const instance = new WebAssembly.Instance(module, imports);
    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;


    if (typeof module_or_path !== 'undefined') {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
            ({module_or_path} = module_or_path)
        } else {
            console.warn('using deprecated parameters for the initialization function; pass a single object instead')
        }
    }

    if (typeof module_or_path === 'undefined') {
        module_or_path = new URL('validation_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync };
export default __wbg_init;
